import React from 'react';
import cx from 'classnames';
import ContentsTree, {
  ContentSTreeProps,
} from '@features/components/contents-tree';
import { AnchorTo } from '../AnchorTo';
import styles from './index.scss';

interface ContentMenuProps extends ContentSTreeProps {
  anchor?: string;
}

export const ContentMenu = ({ anchor, ...props }: ContentMenuProps) => {
  return (
    <ContentsTree
      {...props}
      className={cx(styles.ContentMenu, props.className)}
      renderMenuItem={(_, originElement) => (
        <>
          {anchor && <AnchorTo anchor={anchor} />}
          {originElement}
        </>
      )}
    />
  );
};
